export class officeLocationUrl {
    Get_ALL_LOCATION_URL = "suite/location/all[?FilterText][&PageNumber]";
    LOCATION_BY_ID_URL= "suite/location/{locationId}";    
}